import gql from 'graphql-tag';

export const CREATE_SERVICE_RUN = gql`
	mutation createServiceRunMutation($input: CreateServiceRunInput!) {
		createServiceRun(input: $input) {
			id
		}
	}
`;

